var _path, _g, _g2, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    fill: "#ee1c25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.936022 125.19583a27.917245 27.917245 0 0 0-14.901582 41.791893 45.171052 45.171052 0 0 1-20.289932 66.204239 38.650583 38.650583 0 0 0-10.816469 64.313021 68.374981 68.374981 0 0 1-17.067835-93.913589 15.809868 15.809868 0 0 1-1.109109-1.047777 69.880683 69.880683 0 0 0 16.754434 95.793146 90.342104 90.342104 0 0 1 47.430493-173.140933",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.979333 181.099409l-27.564739 12.021638 29.366483 6.476437-19.951229-22.500734 2.915284 29.930515"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72 450 300)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(216 450 300)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72 450 300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.b5ee86af3d697ea255c9df09793d980d.svg";
export { ForwardRef as ReactComponent };